import request from '@/utils/request'

export async function getData(params, inOut = 'inCounts') {
  return request({
    url: '/v2/statistics/vehicleType/' + inOut,
    method: 'get',
    params,
  })
}
export async function exportReport(params, inOut = 'inCounts') {
  return request({
    url: '/v2/statistics/vehicleType/' + inOut + 'Export',
    method: 'get',
    params,
  })
}
